// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__SoYA9","gfeWrapper":"CalendarEvent_gfeWrapper__2aIjX"};